import script from "./TProjetos.vue?vue&type=script&lang=ts&setup=true"
export * from "./TProjetos.vue?vue&type=script&lang=ts&setup=true"

import "./TProjetos.vue?vue&type=style&index=0&id=3b162d8a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b162d8a"]])

export default __exports__